import { IFileSource, IMapping, IMappingDetail, IMappingVersion, IRawMetaData, IStep } from "@samc/centricity-core";
import { IDataImportAutosaveBlob, IEnrichmentImportData } from "./IDataImportAutosaveBlob";

export enum EnumImportActions {
  ActionSetExtraParams = "setExtraParams",
  ActionSetFileSource = "setFileSource",
  ActionSetMetadata = "setMetaData",
  ActionSetBasicMetadata = "setBasicMetadata",
  ActionSetMapping = "setMapping",
  ActionSetMappingVersion = "setMappingVersion",
  ActionSetStep = "setStep",
  ActionSetCurrentStep = "setCurrentStep",
  ActionSetSteps = "setSteps",
  ActionSetEnrichmentData = "setEnrichmentData",
  ActionSetSyncAutoSave = "setSyncAutoSave",
}

enum EnumImportMutations {
  SetExtraParams = "SET_EXTRAPARAM",
  SetFileSource = "SET_FILESOURCE",
  SetMetadata = "SET_METADATA",
  SetBasicMetadata = "SET_BASICMETADATA",
  SetMapping = "SET_MAPPING",
  SetMappingVersion = "SET_MAPPING_VERSION",
  SetStep = "SET_STEP",
  SetCurrentStep = "SET_CURRENTSTEP",
  SetSteps = "SET_STEPS",
  SetEnrichmentData = "SET_ENRICHMENTDATA",
  SetSyncAutoSave = "SET_SYNCAUTOSAVE",
}

export default {
  state: (): IDataImportAutosaveBlob => ({
    extraParams: null,
    fileSource: null,
    metadata: null,
    basicMetadata: null,
    mapping: null,
    mappingVersion: null,
    step: null,
    currentStep: null,
    steps: null,
    enrichmentData: null,
    syncAutoSave: true
  }),
  mutations: {
    SET_EXTRAPARAM(state: IDataImportAutosaveBlob, extraparams: Record<string, string>) {
      state = state ?? null;
      if(state !== null )
        state.extraParams = extraparams;
    },
    SET_FILESOURCE(state: IDataImportAutosaveBlob, fileSource: IFileSource) {
      state = state ?? null;
      if (state !== null)
        state.fileSource = fileSource;
    },
    SET_METADATA(state: IDataImportAutosaveBlob, metaData: IRawMetaData) {
      state = state ?? null;
      if (state !== null)
        state.metadata = metaData;
    },
    SET_BASICMETADATA(state: IDataImportAutosaveBlob, basicMetaData: IRawMetaData) {
      state = state ?? null;
      if (state !== null)
        state.basicMetadata = basicMetaData
    },
    SET_MAPPING(state: IDataImportAutosaveBlob, mapping: IMapping<IMappingDetail>) {
      state = state ?? null;
      if (state !== null)
        state.mapping = mapping;
    },
    SET_MAPPING_VERSION(state: IDataImportAutosaveBlob, mappingVersion: IMappingVersion) {
      state = state ?? null;
      if (state !== null)
        state.mappingVersion = mappingVersion;
    },
    SET_STEP(state: IDataImportAutosaveBlob, step: string) {
      state = state ?? null;
      if (state !== null)
        state.step = step;
    },
    SET_CURRENTSTEP(state: IDataImportAutosaveBlob, step: IStep) {
      state = state ?? null;
      if (state !== null)
        state.currentStep = step;
    },
    SET_STEPS(state: IDataImportAutosaveBlob, steps: IStep[]) {
      state = state ?? null;
      if (state !== null)
        state.steps = steps;
    },
    SET_ENRICHMENTDATA(state: IDataImportAutosaveBlob, enrichmentData: IEnrichmentImportData) {
      state = state ?? null;
      if (state !== null)
        state.enrichmentData = enrichmentData;
    },
    SET_SYNCAUTOSAVE(state: IDataImportAutosaveBlob, syncAutoSave: boolean) {
      state = state ?? null;
      if (state !== null)
        state.syncAutoSave = syncAutoSave;
    }
  },
  actions: {
    setExtraParams(context: any, extraparams: Record<string, string>) {
      context.commit(EnumImportMutations.SetExtraParams, extraparams);
    },
    setFileSource(context: any, fileSource: IFileSource) {
      context.commit(EnumImportMutations.SetFileSource, fileSource);
    },
    setMetaData(context: any, metadata: IRawMetaData) {
      context.commit(EnumImportMutations.SetMetadata, metadata);
    },
    setBasicMetadata(context: any, basicMetadata: IRawMetaData) {
      context.commit(EnumImportMutations.SetBasicMetadata, basicMetadata);
    },
    setMapping(context: any, mapping: IMapping<IMappingDetail>) {
      context.commit(EnumImportMutations.SetMapping, mapping);
    },
    setMappingVersion(context: any, mappingVersion: IMappingVersion) {
      context.commit(EnumImportMutations.SetMappingVersion, mappingVersion);
    },
    setStep(context: any, step: string | null) {
      context.commit(EnumImportMutations.SetStep, step);
    },
    setCurrentStep(context: any, step: IStep | null) {
      context.commit(EnumImportMutations.SetCurrentStep, step);
    },
    setSteps(context: any, step: IStep[] | null) {
      context.commit(EnumImportMutations.SetSteps, step);
    },
    setEnrichmentData(context: any, enrichmentData: IEnrichmentImportData | null) {
      context.commit(EnumImportMutations.SetEnrichmentData, enrichmentData);
    },
    setSyncAutoSave(context: any, syncAutoSave: boolean | null) {
      context.commit(EnumImportMutations.SetSyncAutoSave, syncAutoSave);
    }
  },
  getters: {
    getState(state: IDataImportAutosaveBlob) {
      return state;
    }
  }
}